import { render, staticRenderFns } from "./imgChevron.vue?vue&type=template&id=66332d7c&scoped=true"
import script from "./imgChevron.vue?vue&type=script&lang=js"
export * from "./imgChevron.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66332d7c",
  null
  
)

export default component.exports